<div class="diagnostic-root">
  <header class="diag-header">
    <div>
      <div class="eyebrow">Support diagnostics</div>
      <h2>{{ userName || 'Anonymous User' }}</h2>
      <p>Environment: {{ environment }}</p>
    </div>
  </header>

  <section class="status-strip">
    <div class="status-item">
      <span>Public IP</span>
      <strong>{{ isLoadingPublicIp ? 'Loading...' : (publicIp || '-') }}</strong>
    </div>
    <div class="status-item">
      <span>Connection</span>
      <strong [class.online]="online" [class.offline]="!online">{{ online ? 'Online' : 'Offline' }}</strong>
    </div>
    <div class="status-item">
      <span>Browser</span>
      <strong>{{ browser || '-' }}</strong>
    </div>
  </section>

  <div class="diagnostic-grid">
    <section class="panel panel-wide">
      <h3>Current work context</h3>
      <dl>
        <dt>Company</dt><dd>{{ companyName || '-' }}</dd>
        <dt>Customer</dt><dd>{{ customerName || '-' }}</dd>
      </dl>
    </section>

    <section class="panel">
      <h3>Device</h3>
      <dl>
        <dt>Operating system</dt><dd>{{ osName || '-' }}</dd>
        <dt>CPU cores</dt><dd>{{ cpuCores || '-' }}</dd>
        <dt>Device memory</dt><dd>{{ deviceMemory || 'unknown' }} GB</dd>
        <dt>Language</dt><dd>{{ language || '-' }}</dd>
        <dt>Timezone</dt><dd>{{ timezone || '-' }}</dd>
      </dl>
    </section>

    <section class="panel">
      <h3>Display</h3>
      <dl>
        <dt>Screen</dt><dd>{{ screenResolution || '-' }}</dd>
        <dt>Window</dt><dd>{{ viewport || '-' }}</dd>
        <dt>Pixel ratio</dt><dd>{{ devicePixelRatio }}</dd>
        <dt>Theme</dt><dd>{{ colorScheme }}</dd>
      </dl>
    </section>

    <section class="panel panel-wide">
      <h3>Network</h3>
      <dl>
        <dt>Status</dt><dd>{{ online ? 'Online' : 'Offline' }}</dd>
        <dt>Connection type</dt><dd>{{ connection || '-' }}</dd>
        <dt>Downlink</dt><dd>{{ downlinkMbps !== null ? (downlinkMbps + ' Mbps') : '-' }}</dd>
        <dt>Round trip time</dt><dd>{{ rtt !== null ? (rtt + ' ms') : '-' }}</dd>
      </dl>
      <div class="meta">Last updated: {{ lastUpdatedAt || '-' }}</div>
    </section>
  </div>
</div>
